'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "currentColor",
    d: "M21.092 7.794 17.456 4.46l-.006-2.692a.9.9 0 0 0-.903-.847l-.61-.009a.87.87 0 0 0-.895.873l-.005.458L13.003.379l-.136-.125a.954.954 0 0 0-.336-.196l-.016-.005a1.022 1.022 0 0 0-.153-.039c-.021-.003-.042-.004-.064-.006a.741.741 0 0 0-.219 0c-.021.002-.043.003-.064.006a1.028 1.028 0 0 0-.153.04l-.016.003a.954.954 0 0 0-.336.197l-.136.125-8.088 7.415a.87.87 0 0 0-.04 1.25l.206.213a.9.9 0 0 0 1.234.095l.615-.55v14.305a.894.894 0 0 0 .895.893h11.986a.894.894 0 0 0 .894-.893V8.802l.615.55a.9.9 0 0 0 1.235-.095l.206-.214a.87.87 0 0 0-.04-1.25ZM11.063 19.452H7.459V15.93h3.604v3.523Zm0-6.245H7.459V9.684h3.604v3.523Zm5.803 6.245h-3.604V15.93h3.604v3.523Zm0-6.245h-3.604V9.684h3.604v3.523Z"
  }));
});
var Level2 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Level2 = Level2;